import { makeStyles } from '@material-ui/core/styles'
import { StateSelector } from './StateSelector'
import { CitySelector } from './CitySelector'
import { SiteAddress } from './SiteAddress'

const useStyles = makeStyles((theme) => {
    return {
        label: {
            marginBottom: '0.5rem',
        },
        btn: {
            width: 'max-content',
            textTransform: 'none',
            marginBottom: '2rem',
        },
        flex: {
            display: 'flex',
            justifyItems: 'space-between',
            gap: theme.spacing(2),
        },

        fullWidth: {
            width: '100%',
        },
    }
})

export const Address = () => {
    const classes = useStyles()

    return (
        <>
            <section className={classes.flex}>
                <StateSelector />
                <CitySelector />
            </section>
            <SiteAddress />
        </>
    )
}
